import './index.scss'
import { Suspense } from 'react'
import Loader from 'react-loaders'


const Logo = () => {

  return (
    <Suspense fallback={<Loader type="pacman" />}>
       <div className='logo-container'>
           <video
               src="/videos/cube.optim.mp4"
               loop
               muted
               playsInline
               preload="auto"
               autoPlay
               tabIndex={-1}
               disablePictureInPicture
               controls={false}
               controlsList="nodownload noplaybackrate noremoteplayback"
               onContextMenu={(e) => e.preventDefault()}
           />
    </div>
   </Suspense>
  )
}

export default Logo
